// extracted by mini-css-extract-plugin
export default {"table_wrapper":"Bulanan_table_wrapper__fIwpY","status_header":"Bulanan_status_header__GVNp4","status":"Bulanan_status__4wg1P","cell":"Bulanan_cell__CHyon"};